module.exports = __webpack_public_path__ + "img/p-10-2.af3d8a8f.png";